import React from "react";
import KC_UIText from "../../../../../../designsystem/typography/KC_UIText/KC_UIText";
import { KC_Weights } from "../../../../../../designsystem/ds_commons";
import KC_CustomSelect, {
  KC_CustomSelectChild
} from "../../../../../../designsystem/KC_CustomSelect/KC_CustomSelect";
import { tt } from "../../../../../../utils/i18n/i18n";
import KC_Checkbox from "../../../../../../designsystem/KC_FormInput/KC_Checkbox";
import { POSAOptionType } from "@tootsweet/model/entities/UploadedPOSA";

interface Props {
  id: string;
  label: string;
  selectOptions: POSAOptionType[];
  selected: POSAOptionType[];
  setSelected: React.Dispatch<React.SetStateAction<POSAOptionType[]>>;
  isSelectMultiple?: boolean;
}

export default function ChooseSupports(props: Props) {
  const getSelectedItemsCount = (nItems = 0) => {
    if (nItems <= 0) return "";
    const key =
      nItems > 1
        ? "posa_form_items_selected_plural"
        : "posa_form_items_selected";
    return tt(key, { count: nItems });
  };

  const handleCheck = (option: POSAOptionType, isChecked: boolean) => {
    if (isChecked) {
      props.setSelected((prev) =>
        prev.filter((s) => s.format !== option.format)
      );
    } else if (!props.isSelectMultiple) {
      props.setSelected([option]);
    } else if (option.format === "none") {
      props.setSelected([{ format: "none", displayName: "" }]);
    } else {
      props.setSelected((prev) =>
        prev.filter((s) => s.format !== "none").concat(option)
      );
    }
  };

  return (
    <div className="mb-5">
      <label className="mb-3">
        <KC_UIText weight={KC_Weights.md} text={props.label} />
      </label>
      <KC_CustomSelect
        id={props.id}
        className="dropdown"
        placeholder={getSelectedItemsCount(props.selected.length) || ""}
      >
        {props.selectOptions.map((option) => {
          const isChecked = props.selected
            .map((item) => item.format)
            .includes(option.format);

          return (
            <KC_CustomSelectChild
              key={option.format}
              onClick={(e) => {
                e?.stopPropagation?.();
                handleCheck(option, isChecked);
              }}
            >
              <div
                id={`${props.id}-option-${option.format}`}
                className="d-flex w-100 gap-sm"
              >
                <KC_Checkbox checked={isChecked} />
                <KC_UIText
                  weight="reg"
                  className="d-inline-block w-100 white-space-normal"
                  text={option.displayName}
                />
              </div>
            </KC_CustomSelectChild>
          );
        })}
      </KC_CustomSelect>
    </div>
  );
}
